import { RECIPE_DATA_API, RECIPE_DATA_LOCAL } from '@models/adminRecipeService';
import { db } from '@config/firebaseConfig';
import { collection, getDocs } from "firebase/firestore";
import {USE_FIREBASE} from "@config/appConfig";

/**
 * It retrieves the product list from an external API or a local file.
 */

const productsCollection = collection(db, "products");

/**
 * Fetches products from Firebase or the Local file depending on the configuration.
 */
export const getAdminRecipeService = async () => {
    if (!USE_FIREBASE) {
        return RECIPE_DATA_LOCAL.map(item => new RECIPE_DATA_API(item));
    }

    try {
        const querySnapshot = await getDocs(productsCollection);

        return querySnapshot.docs.map(doc => {
            const data = { id: doc.id, ...doc.data() };
            return new RECIPE_DATA_API(data);
        });
    } catch (error) {
        return RECIPE_DATA_LOCAL.map(item => new RECIPE_DATA_API(item));
    }
};